import { useCallback, useState } from 'react'
import { reportError } from '@payments-checkout/shared/observability'

type CopiedValue = string | null

type CopyFn = (text: string) => Promise<boolean>

export function useCopyToClipboard(): [CopiedValue, CopyFn] {
  const [copiedText, setCopiedText] = useState<CopiedValue>(null)

  const copy: CopyFn = useCallback(async text => {
    if (!navigator?.clipboard) {
      return false
    }

    try {
      await navigator.clipboard.writeText(text)
      setCopiedText(text)
      return true
    } catch (error) {
      reportError(error, { source: 'clipboard' })
      setCopiedText(null)
      return false
    }
  }, [])

  return [copiedText, copy]
}
